define('presentation/signup/facades/signupEmailFacade',[
        'businessServices/signup/signupSessionStore',
        'common/promises/promiseFactory',
        'constants/numberPickerConstants',
        'persistence/webSocket/webSocketApp',
        'presentation/signup/presentationObjects/signupEmailPresentationObject'],
    function() {
        let _webSocketApp = null;
        let _signupSessionStore = null;

        let SignupEmailPresentationObjectConstructor = require('presentation/signup/presentationObjects/signupEmailPresentationObject');
        const _numberPickerConstants = require('constants/numberPickerConstants');

        const MINIMUM_TIME_TO_WAIT = 3000;
        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _getEmailStatus = (emailAddress) => {
            return _promiseFactory.defer((promise) => {
                const webSocketParameters = {emailAddress: emailAddress};
                _webSocketApp.send("get_email_address_status", webSocketParameters, (result) => {
                    promise.resolve(result);
                });
            });
        };

        const _isEmailOnAnotherHubSpotContact = (emailAddress) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.get()
                    .fail(promise.reject)
                    .done((signupSession) => {
                        const hubSpotContactRecordId = signupSession.hubSpotContactRecordId;
                        if (!hubSpotContactRecordId) {
                            promise.resolve(true);
                            return;
                        }

                        _signupSessionStore.getHubSpotContactByEmail(emailAddress)
                            .fail(promise.reject)
                            .done((response) => {
                                const { hubSpotContact } = response;
                                if (!hubSpotContact) {
                                    promise.resolve(true);
                                    return;
                                }
                                const hubSpotContactId = hubSpotContact.contactId;
                                promise.resolve(hubSpotContactRecordId === hubSpotContactId);
                            });
                    });
            });
        };

        const _saveEmailAddress = (emailAddress) => _signupSessionStore.saveEmailAddress(emailAddress);

        const _sendEmailVerificationCode = () => _signupSessionStore.sendEmailVerificationCode();

        const _setEmailStepCompleted = (emailAddress, verificationCode) => _signupSessionStore.setEmailCompleted(emailAddress, verificationCode);

        const _loadSignupSession = () => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.get()
                    .fail(promise.reject)
                    .done((signupDocument) => {
                        let signupEmailPresentationObject = new SignupEmailPresentationObjectConstructor();
                        signupEmailPresentationObject.emailAddress = signupDocument.emailAddress;
                        signupEmailPresentationObject.isEmailStepCompleted = signupDocument.isEmailCompleted;
                        signupEmailPresentationObject.reservedPhoneNumber = signupDocument.reservedPhoneNumber;
                        signupEmailPresentationObject.emailVerificationCodeSendCount = signupDocument.emailVerificationCodeSendCount;
                        signupEmailPresentationObject.emailVerificationFailureCount = signupDocument.emailVerificationFailureCount;
                        signupEmailPresentationObject.affiliateId = signupDocument.affiliateId;
                        promise.resolve(signupEmailPresentationObject);
                    });
            });
        };

        const waitForMinimumSecondsToPass = (asyncFunctionToExecute) => {
            return _promiseFactory.defer(promise => {
                const endTime = MINIMUM_TIME_TO_WAIT + new Date().getTime();

                const resolveAfterEndTime = result => {
                    const endTimeRemaining = endTime - new Date().getTime();
                    setTimeout(() => {
                        promise.resolve(result);
                    }, endTimeRemaining);
                };

                asyncFunctionToExecute
                    .fail(promise.fail)
                    .done(resolveAfterEndTime);
            });
        };

        const _reservePhoneNumber = ({phoneNumber, region = null, city = null, vanityString = null, numberType, searchType}) => {
            const reservePhoneNumber = _promiseFactory.deferIndefinitely((reserveNumberPromise) => {
                if (numberType === _numberPickerConstants.numberTypes.tollFree) {
                    _signupSessionStore.reservePhoneNumber({phoneNumber, searchType, vanityString})
                        .fail(reserveNumberPromise.reject)
                        .done(reserveNumberPromise.resolve);
                } else if (searchType === _numberPickerConstants.searchTypeEnumeration.default) {
                    _signupSessionStore.reservePhoneNumber({phoneNumber, region, city, searchType})
                        .fail(reserveNumberPromise.reject)
                        .done(reserveNumberPromise.resolve);
                } else {
                    _signupSessionStore.reserveLocalPhoneNumberWithoutLocation({phoneNumber, searchType, vanityString})
                        .fail(reserveNumberPromise.reject)
                        .done(reserveNumberPromise.resolve);
                }
            });
            return waitForMinimumSecondsToPass(reservePhoneNumber);
        };

        const _setPhoneNumberCompleted = (isPhoneNumberCompleted) => _signupSessionStore.setPhoneNumberCompleted(isPhoneNumberCompleted);

        const _init = () => {
            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();

            const WebSocketAppConstructor= require('persistence/webSocket/webSocketApp');
            _webSocketApp = new WebSocketAppConstructor();
            _webSocketApp.init("validation");
        };


        return function() {
            let self = this;

            self.init = _init;

            self.getEmailStatus = _getEmailStatus;
            self.isEmailOnAnotherHubSpotContact = _isEmailOnAnotherHubSpotContact;
            self.saveEmailAddress = _saveEmailAddress;
            self.sendEmailVerificationCode = _sendEmailVerificationCode;
            self.loadSignupSession = _loadSignupSession;
            self.setEmailStepCompleted = _setEmailStepCompleted;
            self.reservePhoneNumber = _reservePhoneNumber;
            self.setPhoneNumberCompleted = _setPhoneNumberCompleted;
        };
    });

